import PropTypes from 'prop-types'
import invoice from '../../assets/images/food-app/brand/logo.svg'

const LoaderBox = ({ loader, noData, style }) => (
  <>
    {loader && (
      <div className="loading-content" style={style}>
        <div className="content">
          <img src={invoice} alt="Loading" />
          <h1>{loader === true ? 'Loading..' : loader}</h1>
        </div>
      </div>
    )}
    {!loader && noData && (
      <div className="loading-content" style={style}>
        <div className="content">
          <img src={invoice} alt="No Data found" />
          <h1>{noData === true ? 'No Data found..' : noData}</h1>
        </div>
      </div>
    )}
  </>
)

LoaderBox.propTypes = {
  loader: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  noData: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  style: PropTypes.object
}

export default LoaderBox
